package songwritersnotebook.app.data

import kotlinx.serialization.Serializable

enum class VersionType {
    AUTO,
    MANUAL,
    CHECKPOINT
}

@Serializable
data class SongVersion(
    val id: String,
    val songId: String,
    @Serializable(with = songwritersnotebook.app.data.FirestoreLongSerializer::class)
    val timestamp: Long,
    val versionNumber: Int,
    val type: VersionType,
    val notes: String = "",
    val songData: Song // The full snapshot
)
